import { COLOR_RE, DEFAULT_COLOR, SUGGESTED_COLORS, normColor } from '../constants';
import styles from '../../LootboxPage.module.scss';
import ws from '../WorldsPage.module.scss';

/**
 * Champ couleur « #RRGGBB » : sélecteur natif, code hexadécimal en mono, grille de couleurs
 * proposées (9 colonnes de 28 px, anneau sur la couleur courante). `value` peut être en cours de
 * saisie (invalide) : le parent valide (COLOR_RE) et passe son message dans `error`. Le code est
 * mis en majuscules à la frappe et complété d'un « # » en quittant le champ.
 */
export function ColorField({ label = 'Couleur', value, onChange, disabled = false, error, suggestions = SUGGESTED_COLORS }: {
  label?: string;
  value: string;
  onChange: (hex: string) => void;
  disabled?: boolean;
  error?: string | null;
  suggestions?: string[];
}) {
  const valid = COLOR_RE.test(value);
  const cur = value.toUpperCase();
  return (
    <div className={`${styles.field} ${ws.colorField}`} style={{ minWidth: 0 }}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={ws.colorFieldRow}>
        <input type="color" className={ws.colorNative} value={(valid ? value : DEFAULT_COLOR).toLowerCase()} disabled={disabled}
          aria-label={`${label || 'Couleur'} : sélecteur`} onChange={(e) => onChange(e.target.value.toUpperCase())} />
        <input className={`${styles.input} ${ws.colorHex}`} value={value} disabled={disabled} maxLength={7} spellCheck={false}
          placeholder="#RRGGBB" aria-label={`${label || 'Couleur'} : code hexadécimal`} aria-invalid={!!error || undefined}
          onChange={(e) => onChange(e.target.value.trim().toUpperCase())}
          onBlur={() => { const n = normColor(value); if (n && n !== value) onChange(n); }} />
      </div>
      {suggestions.length > 0 && (
        <div className={ws.swatchGrid} role="group" aria-label="Couleurs proposées">
          {suggestions.map((c) => {
            const on = c.toUpperCase() === cur;
            return (
              <button key={c} type="button" className={`${ws.swatch} ${on ? ws.swatchOn : ''}`} style={{ background: c }}
                title={c.toUpperCase()} aria-label={c.toUpperCase()} aria-pressed={on} disabled={disabled}
                onClick={() => onChange(c.toUpperCase())} />
            );
          })}
        </div>
      )}
      {error && <span className={ws.fieldError}>{error}</span>}
    </div>
  );
}
